import { StoreMallDirectorySharp } from "@material-ui/icons";
import React from "react";
import styles from "./Footer.module.css";
import SunTimesLogo from "../SunTimesLogo/SunTimesLogo";

const Footer = () => {
  return (
    <footer className={styles.Footer}>
      <div className={styles.Wrapper}>
        <div className={styles.Logo}>
          <SunTimesLogo darkMode={true} mode={"Small"} />
        </div>
        <ul className={styles.Policies}>
          <li>
            <a href="https://chicago.suntimes.com/legal/terms-of-use">
              Terms of Use
            </a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/legal/privacy-notice">
              Privacy Notice
            </a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/legal/cookie-policy">
              Cookie Policy
            </a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/contact#donotsell">
              Do not sell my info
            </a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/legal/accessibility">
              Accessibility
            </a>
          </li>
          <li>
            <a href="https://status.voxmedia.com/">Platform Status</a>
          </li>
        </ul>
        <ul className={styles.Contact}>
          <li>
            <a href="https://chicago.suntimes.com/pages/contact-us">
              Contact Us
            </a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/contact">Customer Support</a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/masthead">Masthead</a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/contact#tip">Send Us a Tip</a>
          </li>
          <li>
            <a href="https://chicago.suntimes.com/pages/terms-of-sale">
              Terms of Sale
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
